import { resolveImage, resolveLink, resolveRTC, resolveString } from '@/utils/resolvers';

import { MenuGroup } from '../GlobalHeader/GlobalHeader.interface';

export const menuGroupResolver = ({ rawVal: menuGroup, page, pageModels }: any) => {
  const menuItemParser = (item: any) => ({
    image: resolveImage({ rawVal: item?.image, page }),
    link: resolveLink({ rawVal: item?.link, page, pageModels }),
    menuDescription: item?.menuDescription && resolveRTC({ rawVal: item?.menuDescription[0] }),
    linkStyle: resolveString({ rawVal: item?.linkStyle || '' }),
  });

  const menuSectionParse = (section: any) => {
    const { menuItem, primaryNavigationColumnTitle } = section;
    return {
      primaryNavigationColumnTitle: resolveLink({
        rawVal: primaryNavigationColumnTitle,
        page,
        pageModels,
      }),
      menuItem: menuItem.map(menuItemParser),
    };
  };

  const headMenuGroup = menuGroup?.length > 0 ? menuGroup[0] : {};
  const { contentList = [] } = headMenuGroup;

  return contentList.map(menuSectionParse);
};

export default function resolver({ rawVal, page, pageModels }: any): MenuGroup {
  const { menuGroup } = rawVal;

  return {
    verticalDivider: false,
    menuGroupList: menuGroupResolver({ rawVal: menuGroup, page, pageModels }),
  };
}
